import React from "react";

import { useTranslations } from "@narvar/nth-hook-translations";
import Button from "@narvar/nth-block-button";
import { MediumHeader } from "@narvar/nth-bit-header";

import LanguageKeys from "../../ReviewSummary/consts/language_en_US";
import { useLanguage } from "@narvar/nth-kit-returns-headless";
import Icon from "../../ReviewSummary/components/Icon";
import { FileUpload, Language } from "../../ReviewSummary/components";

const tempLanguageKeys = {
  returnsReasonsPicturesTitle: LanguageKeys.returnsReasonsPicturesTitle,
  returnsReasonsPicturesUploadButton:
    LanguageKeys.returnsReasonsPicturesUploadButton,
  returnsReasonsPicturesUploadDescription:
    LanguageKeys.returnsReasonsPicturesUploadDescription,
};

const ReturnReasonsPictures = ({
  pictures,
  maxSize,
  minCount,
  maxCount,
  hideSubmit,
  onChange,
  onSubmit,
}: {
  pictures?: File[];
  maxSize?: number;
  minCount?: number;
  maxCount?: number;
  hideSubmit?: boolean;
  onChange?: (pictures: File[]) => void;
  onSubmit?: () => void;
}) => {
  const {
    returnsReasonsPicturesTitle,
    returnsReasonsPicturesUploadButton,
    returnsReasonsPicturesUploadDescription,
  } = tempLanguageKeys;
  const { returnsActionsNext } = useTranslations();

  const uploadButtonLabel = useLanguage({
    langKey: "returnsReasonsPicturesUploadButton",
    defaultString: returnsReasonsPicturesUploadButton,
  }).value;

  const uploadCaption = useLanguage({
    langKey: "returnsReasonsPicturesUploadDescription",
    defaultString: returnsReasonsPicturesUploadDescription,
  }).value;

  const isValid =
    (!maxCount || maxCount >= (pictures?.length ?? 0)) &&
    (!minCount || minCount <= (pictures?.length ?? 0));

  const handleChange = (acceptedFiles: File[]) => {
    onChange?.(acceptedFiles);
  };
  const handleSubmit = () => {
    onSubmit?.();
  };

  return (
    <>
      <MediumHeader>
        <Language
          langKey="returnsReasonsPicturesTitle"
          defaultString={returnsReasonsPicturesTitle}
        />
      </MediumHeader>

      <Icon icon="PlaceholderPictures" />
      <FileUpload
        accept=".jpg, .jpeg, .png"
        multiple={maxCount !== 1}
        maxSize={maxSize}
        maxCount={maxCount}
        outline
        big
        label={uploadButtonLabel}
        caption={uploadCaption}
        value={pictures}
        onChange={handleChange}
      />

      {!hideSubmit && (
        <Button big disabled={!isValid} onClick={handleSubmit}>
          <Language
            langKey="returnsActionsNext"
            defaultString={returnsActionsNext}
          />
        </Button>
      )}
    </>
  );
};

export default ReturnReasonsPictures;
